__turbopack_context__.v({
  "cardBox": "WhatYouGetSection-module__5I0k9q__cardBox",
  "cardRow": "WhatYouGetSection-module__5I0k9q__cardRow",
  "headerWhat": "WhatYouGetSection-module__5I0k9q__headerWhat",
  "icon": "WhatYouGetSection-module__5I0k9q__icon",
  "iconWhat": "WhatYouGetSection-module__5I0k9q__iconWhat",
  "leftBlockWhat": "WhatYouGetSection-module__5I0k9q__leftBlockWhat",
  "leftGroup": "WhatYouGetSection-module__5I0k9q__leftGroup",
  "mainHeading": "WhatYouGetSection-module__5I0k9q__mainHeading",
  "rightSection": "WhatYouGetSection-module__5I0k9q__rightSection",
  "section": "WhatYouGetSection-module__5I0k9q__section",
  "signupBtn": "WhatYouGetSection-module__5I0k9q__signupBtn",
  "subText": "WhatYouGetSection-module__5I0k9q__subText",
  "textGroup": "WhatYouGetSection-module__5I0k9q__textGroup",
  "titleWhat": "WhatYouGetSection-module__5I0k9q__titleWhat",
});
